import valuer_api from "../../api/valuer";
import address_formatter from "../../utils/Address";
import {useEffect, useState} from "react";
import ButtonLoadingWheel from "../ButtonLoadingWheel";
import papi from "../../api/pdf";
import GenericDialog from "../GenericDialog";
import {useNavigate} from "react-router-dom";
import ValuerAmendFreeTextInput from "./ValuerAmendFreeTextInput";


const ValuerAmendClientData = (props) => {
    const navigate = useNavigate();

    const [downloading, setDownloading] = useState(false);
    const [downloadingCSV, setDownloadingCSV] = useState(false);
    const [requestedBefore, setRequestedBefore] = useState(false);
    const [previousRequests, setPreviousRequests] = useState([]);
    const [clientReference, setClientReference] = useState("");

    const sectionName = "Client"

    const csvFilename = props.csvFilename

    const summaryId = props.summaryId

    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (!summaryId) return
        RequestedBeforeCheck()
    }, [summaryId])

    const DownloadCSV = () => {
        setDownloadingCSV(true)
        let response = valuer_api.getValuerCsv(summaryId);
        response.then(
            response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', csvFilename);
                document.body.appendChild(link);
                link.click();
            }
        ).catch((err) => {
            setErrorMessage("Failed to download the requests csv");
            setErrorTitle("Download failed");
        }).finally(() => setDownloadingCSV(false))
    }

    const RequestedBeforeCheck = () => {
        let response = valuer_api.ValuationRequestedBeforeCheck(summaryId);
        response.then(
            response => {
                setRequestedBefore(response.data.requested_before)
                setPreviousRequests(response.data.previous_requests)
            }
        ).catch((err) => {
            setErrorMessage("Failed to check if property has been requested before");
            setErrorTitle("Request failed");
        })
    }

    const DownloadReport = (summary_id, filename) => {
        setDownloading(true)
        let response = papi.getReport(summary_id);
        response.then(
            response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            }
        ).catch((err) => {
            setErrorMessage("Failed to download the properties CSV");
            setErrorTitle("Download failed");
        }).finally(() => setDownloading(false))
    }

    useEffect(() => {
        GetValuesForAccordion()
    }, [summaryId, sectionName]);

    const GetValuesForAccordion = () => {
        if (!summaryId || !sectionName) return;
        let response = valuer_api.ValuerAmendGet(summaryId, sectionName);
        response.then(
            response => {
                let _val = response.data.values;
                setClientReference(_val["client-reference-number"]);
            }
        ).catch((err) => {
            setErrorTitle("Valuation Request Error")
            setErrorMessage("There was an error getting the Valuation Request - Please Try Again")
        })
    }


    const UpdateParentValue = (identifier, value) => {
        if (!identifier) return
        setClientReference(value)
    }

    return (
        <>
            <div className="valuer-amend-form-subtitle">
                Data Provided by the client
            </div>
            <div className="valuer-amend-form-csv-link link" onClick={() => DownloadCSV()}>
                {downloadingCSV && downloadingCSV ? <ButtonLoadingWheel show={downloadingCSV} /> : "View CSV"}
            </div>

            {requestedBefore && requestedBefore ?
                <>
                    <div className="valuer-amend-form-subtitle">
                        This property has been requested before by FINVISE.
                    </div>
                    <div className="valuer-amend-client-previous-requests-container">
                        {previousRequests && previousRequests.map((request, idx) => {
                            return (
                                <div className="valuer-amend-client-previous-request-row-container">
                                    <div className="valuer-amend-client-previous-request-column link" onClick={() => {
                                        navigate(`/valuer/review/${request.valuer_reports_id}`)
                                    }}>
                                        View ticket
                                    </div>
                                    <div className="valuer-amend-client-previous-request-column link" onClick={() => {
                                        DownloadReport(request.summary_id, request.report)
                                    }}>
                                        View PDF
                                    </div>
                                    <div className="valuer-amend-client-previous-request-column">
                                        {request.valuer}
                                    </div>
                                    <div className="valuer-amend-client-previous-request-column">
                                        {request.status}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </>
                :
                <div className="valuer-amend-form-subtitle">
                    This property has not been requested on the FINVISE platform before.
                </div>
            }
            <ValuerAmendFreeTextInput sectionName="Client"
                                      identifier="client-reference-number"
                                      textLimit={1024}
                                      value={clientReference}
                                      field="Client reference number"
                                      height='48px'
                                      width='241px'
                                      placeholder=""
                                      summaryId={summaryId}
                                      AddToQueue={AddToQueue.bind(this)}
                                      RemoveFromQueue={RemoveFromQueue.bind(this)}
                                      // UpdateParentValue={UpdateParentValue}
                                      AddToErroredSaves={AddToErroredSaves.bind(this)}
                                      setErrorMessage={setErrorMessage}
                                      setErrorTitle={setErrorTitle}
                                      />

            {downloading ? <GenericDialog title="Download" text="Your download is being prepared"/> : null}
        </>

    )
}

export default ValuerAmendClientData;
